import { z } from 'zod/v4';

export interface IStreet {
  street: string;
}

export interface IStreetListRequest {
  countryCode: string;
  city: string;
  postCode: string;
  street?: string;
}

export const STREET_SCHEMA: z.ZodType<IStreet> = z.object({
  street: z.string(),
});

export const STREETS_SCHEMA: z.ZodType<IStreet[]> = z.array(STREET_SCHEMA);
